export default __webpack_public_path__ + "static/media/search.cee6790d.png";